import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=05489f98&scoped=true&"
import script from "./ContentPage.vue?vue&type=script&lang=js&"
export * from "./ContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ContentPage.vue?vue&type=style&index=0&id=05489f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05489f98",
  null
  
)

export default component.exports